<div mat-dialog-title class="dialog-header d-flex justify-content-between">
  @if (type === 'Add') {
    <div i18n="@@addNewCompetitor">Add New Competitor</div>
  }
  @if (type !== 'Add') {
    <div i18n="@@editCompetitor">Edit Competitor</div>
  }
  <mat-icon (click)="closeDialog()" class="cursor" i18n-label="@@closeDialogIcon" aria-label="Close">close</mat-icon>
</div>

<mat-dialog-content>
  <form [formGroup]="addCompetitorForm">
    <div class="form-group">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@modalNameLabel">Model name</mat-label>
        <input data-testid="modal_name_input" matInput id="modal_name" placeholder="Model name" i18n-placeholder="@@modalNamePlaceholder" name="modal_name" formControlName="modal_name" required />
        <mat-error>  
          @if (!addCompetitorForm.get('modal_name').valid && addCompetitorForm.get('modal_name').touched) {
            @if (addCompetitorForm.get('modal_name').errors && addCompetitorForm.get('modal_name').errors['required'] || addCompetitorForm.get('modal_name').hasError('whitespace')) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
          }
        </mat-error>
      </mat-form-field>

      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@manufacturerDepartmentLabel">Manufacturer name</mat-label>
        <input data-testid="manufacturer_name_input" matInput id="manufacturer_name" placeholder="Manufacturer name" i18n-placeholder="@@manufacturerDepartmentPlaceholder" name="manufacturer_name" formControlName="manufacturer_name" required>
        <mat-error>  
          @if (!addCompetitorForm.get('manufacturer_name').valid && addCompetitorForm.get('manufacturer_name').touched) {
            @if (addCompetitorForm.get('manufacturer_name').errors && addCompetitorForm.get('manufacturer_name').errors['required'] || addCompetitorForm.get('manufacturer_name').hasError('whitespace')) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
          }
        </mat-error>
      </mat-form-field>
    </div>

    <div>
      @if (type === 'Add') {
        <button i18n="@@add" data-testid="add_competitor_button" class="w-100" mat-raised-button color="primary" (click)="onSubmit()">Add</button>
      }
      @if (type !== 'Add') {
        <button i18n="@@save" data-testid="edit_competitor_button" class="w-100" mat-raised-button color="primary" (click)="onSubmit()">Save</button>
      }
    </div>
  </form>
</mat-dialog-content>